import React, { useEffect } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  SafeAreaView,
  ScrollView,
  ActivityIndicator,
} from 'react-native';
import { Icon } from 'react-native-elements';
import Modal from 'react-native-modal';
import HTML from 'react-native-render-html';
import styles from './styles';
import config from '../../lib/config';

const TermModal = ({
  termsContent,
  isLoading,
  isVisible,
  onClose,
  title,
}: any) => {
  const closeIcon = 'close';
  return (
    <Modal
      isVisible={isVisible}
      backdropColor={'#000000'}
      backdropOpacity={0.5}
      hideModalContentWhileAnimating
      style={styles.overlay}
      onBackdropPress={onClose}
    >
      <View style={styles.topOverlay}>
        <View style={styles.closeButtonContainer}>
          <TouchableOpacity onPress={onClose}>
            <Icon
              tvParallaxProperties={null}
              activeOpacity={0.5}
              name={closeIcon}
              size={26}
              color={'#505050'}
            />
          </TouchableOpacity>
          {title && <Text style={styles.title}>{title}</Text>}
        </View>
      </View>
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        style={styles.scrollView}
      >
        {isLoading ? (
          <View style={styles.loaderContainer}>
            <ActivityIndicator color={config.theme.brandColor} />
          </View>
        ) : (
          <View style={styles.htmlContent}>
            <HTML source={{ html: termsContent }} />
            <TouchableOpacity onPress={onClose}>
              <Icon
                tvParallaxProperties={null}
                activeOpacity={1}
                name={closeIcon}
                size={26}
                style={styles.modalIcon}
                color={'#505050'}
                iconStyle={styles.iconBase}
              />
            </TouchableOpacity>
          </View>
        )}
      </ScrollView>
    </Modal>
  );
};

export default React.memo(TermModal);
